<template>
  <v-dialog
    :value="value"
    persistent
    max-width="50%"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="primary">
        <span class="text-h5"> {{ edit ? "Edit" : "Add" }} {{ title }} </span>
      </v-card-title>

      <v-card-text class="mt-6">
        <slot/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CertificationDialog",

  props: {
    value: Boolean,
    edit: Boolean,
    title: String,
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>
